import axios from 'axios'

export default {
  namespaced: true,
  state: {
    businessSegmentGrid: [],
    businessSegmentAll: [],
    businessSegmentShow: null,
    pageData: null,
  },
  mutations: {
    setBusinessSegmentGrid(state, payload) {
      state.businessSegmentGrid = payload
    },
    setBusinessSegmentAll(state, payload) {
      state.businessSegmentAll = payload
    },
    setBusinessSegmentShow(state, payload) {
      state.businessSegmentShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    businessSegmentGrid: (state) => {
      return state.businessSegmentGrid
    },
    businessSegmentAll: (state) => {
      return state.businessSegmentAll
    },
    businessSegmentShow: (state) => {
      return state.businessSegmentShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onBusinessSegmentGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        '/api/admin/work/business-segment/grid?limit=' +
        limit +
        '&page=' +
        page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setBusinessSegmentGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onBusinessSegmentAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/business-segment/grid?limit=0' +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setBusinessSegmentAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onBusinessSegmentShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/business-segment/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setBusinessSegmentShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onBusinessSegmentCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/business-segment',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onBusinessSegmentUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/business-segment',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', { IsError: false }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    // onBusinessSegmentDelete({ rootState }, {id, checkbox}) {
    //     return new Promise((resolve, reject) => {
    //         axios({
    //             url: rootState.apiDomain + '/api/admin/work/business-segment/' + id + '?with_relations=' + checkbox,
    //             checkbox: checkbox,
    //             id: id,
    //             method: 'DELETE'
    //         })
    //             .then(resp => {
    //                 resolve(resp)
    //             })
    //             .catch(err => {
    //                 reject(err)
    //             })
    //     })
    // },
    onBusinessSegmentDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/business-segment/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
